@if (!openEditSidebar) {
  <div class="flex flex-col overflow-auto w-full">
    <div class="flex items-center justify-between w-full mx-auto px-6 pt-4">
      <div class="flex items-center gap-2 text-xl md:text-2xl font-bold">
        {{ service?.name }}
        @if (taskById?.taskId !== 'new') {
          - {{ task?.task?.taskTypeName }} - {{ task?.task?.taskId }}
        }
        <button matTooltip="{{ 'edit' | transloco }}" mat-icon-button (click)="updateTask()">
          <mat-icon class="text-current" [svgIcon]="'mat_outline:edit'"></mat-icon>
        </button>
        <button matTooltip="{{ 'copyTask' | transloco }}" mat-icon-button (click)="copyTask()">
          <mat-icon class="text-current" [svgIcon]="'feather:copy'"></mat-icon>
        </button>
      </div>
      <button mat-icon-button [matTooltip]="'close' | transloco" (click)="close()">
        <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>
    <task-details-sidebar (update)="updateList()"></task-details-sidebar>
  </div>
}
@if (openEditSidebar) {
  <edit-task-sidebar (closeUnchanged)="close()" (update)="updateList()"
    (closeEdit)="goToDetails()">
  </edit-task-sidebar>
}